import type { StoryblokRichTextNode } from "@storyblok/react";
import type { FC, ReactElement } from "react";
import RichText from "../../../RichText";
import * as s from "./AccordionContent.module.scss";

type AccordionContentProps = {
	richtext: string | StoryblokRichTextNode<ReactElement>;
};

const AccordionContent: FC<AccordionContentProps> = ({ richtext }) => {
	return <RichText className={s.accordionRichText} content={richtext} />;
};

export default AccordionContent;
